import React from 'react';
import { Pressable } from 'react-native';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Text from '../text';
import Colors from '../colors';
import Icon from '../icon';
import Spacer from '../spacer';
const StyledContainer = styled.View`
  flex-direction: row;
  padding: 16px;
  background-color: ${Colors.white};
  align-items: center;
  justify-content: space-between;
`;
const StyledIconTile = styled.View`
  width: 32px;
  height: 32px;
  background-color: ${Colors.lightGray200};
  border-radius: 4px;
  justify-content: center;
  align-items: center;
`;
const StyledReason = styled.View`
  flex-direction: row;
  align-items: center;
`;
export default function ReasonCard(props) {
  const StyledIcon = props.iconFamily;
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(StyledContainer, {
    style: styles
  }, /*#__PURE__*/React.createElement(StyledReason, null, /*#__PURE__*/React.createElement(StyledIconTile, null, /*#__PURE__*/React.createElement(StyledIcon, {
    family: props.iconFamily,
    name: props.iconName,
    color: Colors.advanceBlue400,
    size: 20
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray600
  }, props.name)), props.selected && /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "check-circle",
    size: 20,
    color: Colors.mint400
  })));
}
ReasonCard.propTypes = {
  name: PropTypes.string,
  iconName: PropTypes.string,
  iconFamily: PropTypes.elementType,
  selected: PropTypes.bool,
  onPress: PropTypes.func
};
ReasonCard.defaultProps = {
  name: '',
  iconName: '',
  iconFamily: Icon.MaterialIcons,
  selected: false,
  onPress: () => {}
};
const styles = {
  borderBottom: `1px solid ${Colors.lightGray300}`
};
//# sourceMappingURL=reason.js.map